<template>
  <div class="contents">
    <div class="opt">
      <div v-permissson="'add'" class="add flex_c_c" @click="add">
        <svg-icon v-permissson="'add'" className="icon" iconClass="add" /> 新增
      </div>
      <div v-permissson="'export'" class="add flex_c_c" style="margin-left: 10px;margin-right: 10px" @click="downloadFile">
        <svg-icon v-permissson="'export'" className="icon" iconClass="download" /> 导出
      </div>
      <BaseFilter
        :isActive="isActive"
        :width="516"
        @sendFilter="sendFilter"
        @reset="reset"
      >
        <div class="filter">
          <el-form ref="form" :model="filterList" label-width="116px">
            <el-form-item label="中文品名">
              <el-input
                v-model="filterList.nameCH"
                placeholder="请输入中文品名"
                style="width: 320px"
              ></el-input>
            </el-form-item>
            <el-form-item label="英文品名">
              <el-input
                v-model="filterList.nameEN"
                placeholder="请输入英文品名"
                style="width: 320px"
              ></el-input>
            </el-form-item>
            <el-form-item label="税号">
              <el-input
                v-model="filterList.hsCode"
                placeholder="请输入税号"
                style="width: 320px"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </BaseFilter>
    </div>
    <div class="data">
      <BaseTable
        v-if="height !== 0"
        :height="height"
        :tableData="tableData"
        :pageIndex="pager.pageIndex"
        :pageSize="pager.pageSize"
        :loading="loading"
        :isPager="true"
        :isEmptyBorder="true"
        @handlePageChange="handlePageChange"
      >
        <template slot="fileQty" slot-scope="row">
          <div class="fileQty">
            <!-- <img
              v-if="row.scope.row.fileQty > 0"
              src="@/assets/images/table/file.png"
            />
            </img> -->
            <span v-if="row.scope.fileQty > 0">
              {{ row.scope.fileQty }}
              <i
                class="el-icon-folder-opened"
                style="margin-left: 5px; color: #1258bc"
                @click="link(row.scope)"
              />
            </span>
          </div>
        </template>
        <template slot="addRate1" slot-scope="row">
          <p>
            <span class="pickUpType" :class="`pickUpType0`"> 加征税率1 </span>
            {{ `${row.scope.addRate1}%` }}
          </p>
          <p>
            <span class="pickUpType" :class="`pickUpType1`"> 加征税率2 </span>
            {{ `${row.scope.addRate2}%` }}
          </p>
          <p>
            <span class="pickUpType" :class="`pickUpType2`"> 加征税率3 </span>
            {{ `${row.scope.addRate3}%` }}
          </p>
        </template>
        <template slot="opt" slot-scope="row">
          <el-popover
            :ref="`popover${row.scope.id}`"
            placement="bottom-start"
            popper-class="pop-table-opt"
            width="114"
            trigger="click"
          >
            <div class="table-opt">
              <div>
                <el-button
                  v-permissson="'update'"
                  class="opt-item"
                  @click="handleEdit(row.scope)"
                >修改</el-button
                >
                <el-button
                  v-permissson="'delete'"
                  class="opt-item"
                  @click="handleDelete(row.scope)"
                >删除</el-button
                >
              </div>
            </div>
            <img slot="reference" src="@/assets/images/table/opt.png" />
          </el-popover>
        </template>
      </BaseTable>
    </div>
    <AddClearanceConsultationDialog
      :dialogVisible="dialogVisible"
      :editData="editData"
      @cancel="cancel"
      @ok="ok"
    >
    </AddClearanceConsultationDialog>
    <FileListDialog
      :dialogVisible="dialogVisible2"
      :rowData="editData"
      @cancel="dialogVisible2 = false"
    >
    </FileListDialog>
  </div>
</template>

<script>
const BaseTable = () => import('@/components/table/BaseTable')
const BaseFilter = () => import('@/components/filter/BaseFilter')
import { getPages, deleteClearanceConsultation } from '@/api/system'
import { derive } from '@/utils/common'
import { myMixins } from '@/mixins'
import FileListDialog from './components/FileListDialog'
import AddClearanceConsultationDialog from './components/AddClearanceConsultationDialog'
export default {
  name: 'TaxRate',
  components: {
    BaseTable,
    AddClearanceConsultationDialog,
    FileListDialog,
    BaseFilter
  },
  mixins: [myMixins],
  data() {
    return {
      tableData: {
        fileds: [
          {
            filed: 'opt',
            label: '',
            width: '50px',
            isCustom: true,
            fixed: 'left'
          },
          {
            filed: 'createdOn',
            label: '创建时间',
            width: '140',
            formatter: (row) => {
              return row.createdOn.slice(0, 16)
            }
          },
          {
            filed: 'companyName',
            label: '客户',
            width: '150'
          },
          {
            filed: 'nameCH',
            label: '中文品名',
            width: '200'
          },
          {
            filed: 'nameEN',
            label: '英文品名',
            width: '200'
          },
          {
            filed: 'originCountry',
            label: '原产国',
            width: '120'
          },
          {
            filed: 'hsCode',
            label: '海关编码',
            width: '120'
          },
          {
            filed: 'material',
            label: '材质',
            width: '120'
          },
          {
            filed: 'usedFor',
            label: '用途',
            width: '120'
          },
          {
            filed: 'fileQty',
            label: '产品图片',
            width: '120',
            isCustom: true
          },
          {
            filed: 'isClearence',
            label: '是否可清关',
            width: '120',
            formatter: (row) => {
              return row.isClearence ? '是' : '否'
            }
          },
          {
            filed: 'conditions',
            label: '清关条件',
            width: '120'
          },
          {
            filed: 'baseRate',
            label: '基础税率',
            width: '100',
            formatter: (row) => (row.baseRate ? `${row.baseRate}%` : '')
          },
          {
            filed: 'addRate1',
            label: '加征税率',
            width: '140',
            isCustom: true
          },
          {
            filed: 'remark',
            label: '备注',
            width: '120'
          }
        ],
        columns: [],
        total: 0
      },
      loading: false,
      filterList: {
        nameCH: '',
        nameEN: '',
        hsCode: ''
      },
      pager: {
        pageIndex: 1,
        pageSize: 20
      },
      dialogVisible: false,
      dialogVisible2: false,
      editData: {},
      height: 0,
      isActive: false
    }
  },
  created() {
    this.getList(this.pager)
  },
  mounted() {
    this.height = document.querySelector('.data').offsetHeight - 43
  },
  methods: {
    sendFilter() {
      if (
        this.filterList.nameCH !== '' ||
        this.filterList.nameEN !== '' ||
        this.filterList.hsCode !== ''
      ) {
        this.isActive = true
      } else {
        this.isActive = false
      }
      this.pagerConfig = {
        pageIndex: 1,
        pageSize: 20
      }
      this.getList({
        pageIndex: 1,
        pageSize: 20
      })
    },
    reset() {
      this.filterList = {
        nameCH: '',
        nameEN: '',
        hsCode: ''
      }
      this.isActive = false
    },
    async getList(params) {
      this.loading = true
      try {
        params = {
          ...params,
          queryParam: {
            ...this.sortable,
            ...this.formatterFilter()
          }
        }
        const res = await getPages(params)
        if (res.success) {
          this.loading = false
          this.tableData.columns = res.data.list
          this.tableData.total = res.data.total
        } else {
          this.loading = false
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    handleEdit(row) {
      this.editData = row
      this.dialogVisible = true
    },
    handleDelete(row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        iconClass: 'warning',
        showClose: false,
        closeOnPressEscape: false,
        closeOnClickModal: false,
        center: true
      })
        .then(() => {
          deleteClearanceConsultation({
            id: row.id
          }).then((res) => {
            if (res.success) {
              this.$message.success('删除成功')
              this.initList()
            } else {
              this.$message.error(res.errorMessage)
            }
          })
        })
        .catch(() => {})
    },
    add() {
      this.editData = {}
      this.dialogVisible = true
    },
    ok() {
      this.cancel()
      this.initList()
    },
    initList() {
      const params = {
        pageIndex: 1,
        pageSize: 20
      }
      this.pager = params
      this.getList(params)
    },
    cancel() {
      this.dialogVisible = false
      this.editData = {}
    },
    handlePageChange(pager) {
      this.pager = {
        ...pager
      }
      this.getList(pager)
    },
    formatterFilter() {
      return {
        hsCode:
          this.filterList.hsCode !== '' ? this.filterList.hsCode : undefined,
        nameEN:
          this.filterList.nameEN !== '' ? this.filterList.nameEN : undefined,
        nameCH:
          this.filterList.nameCH !== '' ? this.filterList.nameCH : undefined
      }
    },
    async downloadFile() {
      this.loading = true
      const params = {
        ...this.formatterFilter()
      }
      await derive('ClearanceConsultation/export', 'post', params)
      this.loading = false
    },
    link(row) {
      this.editData = row
      this.dialogVisible2 = true
    }
  }
}
</script>

<style lang="less" scoped>
.contents {
  width: 100%;
  padding: 0 10px;
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  overflow: auto;
}
.opt {
  margin: 10px 0;
  display: flex;
  justify-content: flex-end;
  .search {
    position: relative;
    display: flex;
    width: 200px;
    margin-right: 8px;
    .searchPop {
      /deep/ .el-popover {
        z-index: 9999;
        right: 0;
      }
      .close {
        position: absolute;
        top: 6px;
        right: 10px;
        cursor: pointer;
        font-size: 20px;
      }
    }
    .input-search {
      width: 166px;
      height: 30px !important;
      /deep/ .el-input__inner {
        height: 30px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
    .btn-search {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 30px;
      height: 30px;
      border: 1px solid #dbe4f2;
      border-left: 0;
      border-radius: 0 4px 4px 0;
      box-sizing: border-box;
      cursor: pointer;
    }
  }
}
.add {
  width: 84px;
  height: 30px;
  background: rgb(18, 88, 188);
  border-radius: 4px;
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
  svg {
    font-size: 20px;
  }
}
.data {
  width: 100%;
  height: calc(100% - 54px);
  z-index: 1;
  & .fTable {
    border-top: 1px solid #ebeef5;
    box-sizing: border-box;
  }
  &:deep(.el-button) + .el-button {
    margin-left: 30px;
  }
  &:deep(.el-button--text) {
    padding: 0;
  }
  .pickUpType {
    display: inline-block;
    padding: 4px 12px;
    width: auto;
    height: 16px;
    font-size: 12px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    line-height: 16px;
  }
  .pickUpType0 {
    color: rgb(18, 88, 188);
    background: rgba(35, 149, 243, 0.1);
  }
  .pickUpType1 {
    color: rgb(157, 103, 254);
    background: rgba(157, 103, 254, 0.1);
  }
  .pickUpType2 {
    color: #feaa4f;
    background: rgba(254, 170, 79, 0.1);
  }
  .pickUpType3 {
    color: rgb(53, 186, 131);
    background: rgb(224, 249, 238);
  }
}
.sure {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
  padding: 8px 15px;
  font-size: 14px;
  border-radius: 4px;
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  margin-left: 10px;
}
</style>
